export default {
  colors: {
    background: 'hsl(210 40% 98%)',
    card: 'hsl(0 0% 100%)',
    border: 'hsl(214 24% 88%)',

    primary: 'hsl(25 95% 53%)',
    warm: 'hsl(30 80% 55%)',
    sky: 'hsl(190 90% 45%)',
    pink: 'hsl(330 75% 58%)',

    textColor: 'hsl(222 47% 11%)',
    mutedText: 'hsl(215 16% 40%)',

    orange: 'hsl(25 95% 53%)',
    green: 'hsl(0 0% 100%)',

    danger: {
      main: 'hsl(0 84% 60%)',
    },
  },
};
